module.exports = __webpack_public_path__ + "img/read.0a94d5ac.svg";